import React, { useState } from "react";
import "./DevProcess.css";
import RichTextContent, { CmsText } from "../../../../RichTextContent/RichTextContent";
import { useServiceSection } from "../../../../../context/ServicePageContext";
import { getProcessStepsFromSection } from "../../../../../services/contentApi";

const DevProcess = () => {
  const { section, loading } = useServiceSection("dev-process");
  const [active, setActive] = useState(0);

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const steps = getProcessStepsFromSection(section);

  return (
    <section className="process">
      <div className="process__container">
        {fields.label ? (
          <CmsText
            content={fields.label}
            as="span"
            className="process__label"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="process__subtitle"
          />
        ) : null}

        <div className="process__steps">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`process__card ${active === index ? "active" : ""}`}
              onMouseEnter={() => setActive(index)}
            >
              <CmsText
                content={step.id}
                as="span"
                className="process__number"
              />

              {active === index ? (
                <div className="process__content">
                  <CmsText content={step.title} as="h3" />
                  <RichTextContent content={step.desc} />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DevProcess;
